import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "socialLinkedin"
const SocialLinkedinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m7.863 9.199v10.801h-3.653v-10.801zm.232-3.335c.007.53-.179.973-.559 1.33s-.88.534-1.5.534h-.022c-.605 0-1.092-.178-1.46-.535a1.773 1.773 0 0 1 -.554-1.33c0-.537.19-.982.57-1.334.38-.353.876-.529 1.489-.529s1.103.176 1.472.529c.369.352.557.797.564 1.335zm5.423 4.87c.14-.218.285-.41.432-.576a4.75 4.75 0 0 1 .625-.567 2.91 2.91 0 0 1 .963-.474 4.45 4.45 0 0 1 1.267-.169c1.262 0 2.277.413 3.044 1.237.767.825 1.151 2.033 1.151 3.624v6.191h-3.641v-5.777c0-.763-.15-1.36-.449-1.792s-.765-.649-1.4-.649c-.464 0-.854.125-1.167.376-.314.25-.548.561-.703.932-.081.218-.122.512-.122.883v6.027h-3.641c.015-2.9.022-5.25.022-7.052s-.004-2.877-.011-3.226l-.011-.522h3.641z" />
    </svg>
  )
}
export default SocialLinkedinIcon
